<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  // eslint-disable-next-line vue/no-unused-components
}

</script>

<style>

</style>
